'use client'

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion'
import { set } from 'date-fns'
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

export default function FaqSection({faqArt}) {
    const [faqItems, setFaqItems] = React.useState([])
    const [headline, setHeadline] = React.useState('')

    const bewertung = [
        {
            id: 'item-1',
            question: 'Warum sollte ich meine Immobilie bewerten lassen?',
            answer: 'Eine professionelle Bewertung schafft Klarheit – nicht irgendwann, sondern jetzt. Wenn Sie über einen Verkauf nachdenken, sich in einer neuen Lebensphase befinden oder einfach wissen möchten, was Ihre Immobilie aktuell wert ist: Eine fundierte Einschätzung gibt Ihnen Sicherheit. Und sie hilft Ihnen, den richtigen Moment zu erkennen.',
        },
        {
            id: 'item-2',
            question: 'Für wen ist die Bewertung geeignet?',
            answer: 'Unsere Bewertung richtet sich an alle, die vor einer Entscheidung stehen: – Sie haben geerbt und wollen die nächsten Schritte planen? – Eine Trennung oder Scheidung steht an und Sie brauchen Klarheit? – Sie überlegen zu verkaufen – jetzt oder später? Dann ist eine Marktwertanalyse der erste, sinnvolle Schritt. Sie bringt Struktur in komplexe Situationen – ruhig, ehrlich und fundiert.',
        },
        {
            id: 'item-3',
            question: 'Wie genau ist die Bewertung – und wer führt sie durch?',
            answer: 'Unsere Bewertung basiert auf echter Marktkenntnis – nicht auf einem groben Online-Algorithmus. Wir prüfen vergleichbare Objekte, analysieren regionale Entwicklungen und besichtigen Ihre Immobilie persönlich. Die Einschätzung erhalten Sie direkt von einem lokalen Experten. Klar, nachvollziehbar und auf den Punkt.',
        },
        {
            id: 'item-4',
            question: 'Ist die Bewertung wirklich kostenlos?',
            answer: 'Ja – komplett kostenlos und unverbindlich. Sie tragen keine Kosten und gehen keinerlei Verpflichtung ein. Für uns ist das eine Investition in Vertrauen – und in eine gute Entscheidung für Sie.',
        },
        {
            id: 'item-5',
            question: 'Was macht Ihre Bewertung besonders?',
            answer: 'Wir liefern keine Zahlen aus dem Bauch – und keine Standard-Ergebnisse aus einem Online-Rechner. Bei uns steht der Mensch im Mittelpunkt. Ihre Immobilie ist individuell – und genauso individuell behandeln wir sie auch. Vor Ort. Persönlich. Mit Blick für Details. Und mit dem Anspruch, dass Sie sich am Ende wirklich sicher fühlen.',
        },
    ]
    
    const vermietung = [
        {
            id: 'item-1',
            question: 'Warum sollte ich meine Immobilie mit Jakobs Immobilien vermieten?',
            answer: 'Weil eine gute Vermietung mehr ist als nur ein Mietvertrag. Wir begleiten Sie persönlich – vom ersten Gespräch bis zur Schlüsselübergabe. Mit unserer Erfahrung seit 1978, tiefem Marktverständnis und einem klaren Ablauf finden wir für Sie den passenden Mieter – schnell, sicher und mit einem guten Gefühl.',
        },
        {
            id: 'item-2',
            question: 'Wie schnell finden Sie einen passenden Mieter?',
            answer: 'Dank unserer lokalen Vernetzung und sorgfältigen Vorauswahl gelingt es meist in wenigen Wochen einen geeigneten Mieter zu finden. Wir präsentieren Ihre Immobilie gezielt, prüfen Anfragen sorgfältig und führen persönliche Besichtigungen durch. So sparen Sie viel Zeit – und Nerven.',
        },
        {
            id: 'item-3',
            question: 'Wie stellen Sie sicher, dass der Mieter zuverlässig ist?',
            answer: 'Zuverlässigkeit ist kein Zufall – sondern das Ergebnis sorgfältiger Prüfung. Wir prüfen Bonität, Unterlagen und persönliche Passung der Interessenten. So minimieren wir Risiken und sorgen für Sicherheit – für Sie und Ihr Eigentum.',
        },
        {
            id: 'item-4',
            question: 'Was kostet die Vermietung über Jakobs Immobilien?',
            answer: 'Unsere Provision beträgt zwei Nettokaltmieten zzgl. Mehrwertsteuer – fällig erst bei erfolgreicher Vermietung. Für diese Investition erhalten Sie professionelle Vermarktung, geprüfte Interessenten und eine rechtssichere Abwicklung. Fair, transparent und mit echtem Mehrwert für Sie.',
        },
        {
            id: 'item-5',
            question: 'Was ist mit dem Mietvertrag – ist der rechtssicher?',
            answer: 'Ja – und das ist uns besonders wichtig. Wir verwenden aktuelle, geprüfte Vertragsvorlagen und passen diese individuell an Ihr Objekt und Ihre Wünsche an. Auch bei der Übergabe und Protokollierung stehen wir Ihnen zur Seite – damit alles stimmt, von Anfang an.',
        },
        {
            id: 'item-6',
            question: 'Bieten Sie eine kostenfreie Erstberatung an?',
            answer: 'Selbstverständlich. In einem persönlichen Gespräch klären wir Ihre Fragen, beraten zu Mietpreisen und Zielgruppen und besprechen den Ablauf. Unverbindlich, klar und ohne Druck. So gewinnen Sie Sicherheit – und einen Partner, auf den Sie sich verlassen können.',
        },
    ]

    const landingpage =[
        {
            id: 'item-1',
            question: 'Warum sollte ich meine Immobilie mit Jakobs Immobilien verkaufen?',
            answer: 'Der Verkauf einer Immobilie ist ein großer Schritt. Wir begleiten Sie dabei mit Erfahrung aus drei Generationen, tiefem Marktverständnis und einem klaren Plan. Unsere Vorbereitung schützt Sie vor Fehlern, spart Zeit und führt zu einem Verkauf, der wirklich passt – für Sie und den Käufer. Professionell, transparent und mit echtem Engagement.',
        },
        {
            id: 'item-2',
            question: 'Warum sind wir unsere Provision wert?',
            answer: 'Weil wir dafür sorgen, dass am Ende mehr für Sie herauskommt. Ein Immobilienverkauf ist komplex – wir steuern ihn professionell, präsentieren Ihre Immobilie überzeugend und verhandeln mit Erfahrung. So vermeiden Sie Fehler, sparen Zeit und erzielen den besten Preis. Unsere Leistung rechnet sich. ',
        },
        {
            id: 'item-3',
            question: 'Wie viel Zeit spare ich mit Jakobs Immobilien als Makler? ',
            answer: 'Ein Immobilienverkauf braucht Zeit – besonders, wenn man ihn allein angeht. Wie lange es dauert, hängt von vielen Faktoren ab: Lage, Zustand, Nachfrage und nicht zuletzt von der Preisstrategie. Ohne professionelle Begleitung kann ein Verkauf 6 bis 12 Monate in Anspruch nehmen. Mit uns verläuft dieser Prozess strukturiert und effizient. Von der Vorbereitung bis zum Notartermin begleiten wir Sie persönlich – Schritt für Schritt. So gelingt der Verkauf in der Regel innerhalb von 8 bis 12 Wochen. Was Sie davon haben? Mehr Zeit für das, was wirklich zählt – und die Gewissheit, dass Ihre Immobilie in guten Händen ist. ',
        },
        {
            id: 'item-4',
            question: 'Wie wird der Verkaufspreis der Immobilie errechnet? ',
            answer: 'Der Preis entsteht nicht aus dem Bauch heraus – sondern aus Erfahrung und Analyse. Wir bewerten Ihre Immobilie auf Basis von Lage, Zustand, Ausstattung und aktuellen Markttrends. Dabei vergleichen wir ähnliche Objekte in Ihrer Region und ermitteln so einen realistischen, marktgerechten Preis. Ziel ist ein Verkauf, der für Sie das Beste herausholt – ohne falsche Versprechen. ',
        },
        {
            id: 'item-5',
            question: 'Wie hoch ist die Maklerprovision? ',
            answer: 'Unsere Provision beträgt 3,57 % inkl. Mehrwertsteuer – und wird erst fällig, wenn der Verkauf erfolgreich abgeschlossen ist. Sie zahlen also nur im Erfolgsfall. Fair, transparent und ohne Risiko für Sie. ',
        },
        {
            id: 'item-6',
            question: 'Bieten Sie eine kostenfreie Erstberatung an? ',
            answer: 'Ja – der erste Schritt ist für Sie immer unverbindlich und kostenlos. In einem persönlichen Gespräch klären wir, ob und wie wir Sie unterstützen können. Sie erhalten eine erste Einschätzung, Antworten auf Ihre Fragen und – wenn gewünscht – eine fundierte Marktanalyse Ihrer Immobilie. Ohne Verpflichtung, aber mit Klarheit. ',
        },
    ]

    const bewertenHeadline = "Hier finden Sie Antworten auf die wichtigsten Fragen rund um Ihre Immobilienbewertung"
    const vermietenHeadline = "Hier beantworten wir Ihre wichtigsten Fragen zur Vermietung mit Jakobs Immobilien. "
    const lpHeadline = "Verkaufen ist Vertrauenssache. Hier finden Sie klare Antworten auf die wichtigsten Fragen rund um den Immobilienverkauf"

    useEffect(()=>{
        if(faqArt === 'bewerten'){
            setFaqItems(bewertung)
            setHeadline(bewertenHeadline)
        }else if(faqArt === 'vermieten'){
            setFaqItems(vermietung)
            setHeadline(vermietenHeadline)
            return
        }else if(faqArt === 'verkaufen'){
        setFaqItems(landingpage)
        setHeadline(lpHeadline)
        }
    },[])

    return (
        <section className="py-16 md:py-24">
            <div className="mx-auto max-w-5xl px-4 md:px-6">
                <div className="mx-auto max-w-xl text-center">
                    <h2 className="text-balance text-2xl font-bold md:text-3xl lg:text-4xl text-prime-950">Ihre Fragen, unsere Antworten</h2>
                    <p className="text-muted-foreground mt-4 text-balance">{headline}</p>
                </div>

                <div className="mx-auto mt-12 max-w-xl">
                    <Accordion
                        type="single"
                        collapsible
                        className="bg-muted dark:bg-muted/50 w-full rounded-2xl p-1">
                        {faqItems.map((item) => (
                            <div
                                className="group"
                                key={item.id}>
                                <AccordionItem
                                    value={item.id}
                                    className="data-[state=open]:bg-card dark:data-[state=open]:bg-muted peer rounded-xl border-none px-7 py-1 data-[state=open]:border-none data-[state=open]:shadow-sm">
                                    <AccordionTrigger className="cursor-pointer text-base hover:no-underline">{item.question}</AccordionTrigger>
                                    <AccordionContent>
                                        <p className="text-base">{item.answer}</p>
                                    </AccordionContent>
                                </AccordionItem>
                                <hr className="mx-7 border-dashed group-last:hidden peer-data-[state=open]:opacity-0" />
                            </div>
                        ))}
                    </Accordion>

                    <p className="text-muted-foreground mt-6 px-8">
                    Nicht gefunden, was Sie suchen? <br/>
                    <Link
                            to="/unternehmen/kontakt"
                            className="text-primary font-medium hover:underline">
                            Kontaktieren Sie gerne unser Team
                        </Link> – wir helfen Ihnen persönlich weiter. 
                        
                    </p>
                </div>
            </div>
        </section>
    )
}
